var map = {
	"./ActiveNotificationIcon.jsx": 3450,
	"./ActiveRadioButtonIcon.jsx": 8325,
	"./AlcoholIcon.jsx": 3575,
	"./AnalyticsIcon.jsx": 8130,
	"./ArrowBackIcon.jsx": 857,
	"./ArrowBidIcon.jsx": 6394,
	"./ArrowDownIcon.jsx": 4820,
	"./ArrowDownIconNew.jsx": 4738,
	"./ArrowLeftIcon.jsx": 8206,
	"./ArrowRightIcon.jsx": 2286,
	"./ArrowRightRotate2Icon.jsx": 1897,
	"./ArrowRightRotateIcon.jsx": 9962,
	"./ArrowUpIcon.jsx": 9386,
	"./AssignedIcon.jsx": 4937,
	"./AuctionAssignmentMethodIcon.jsx": 565,
	"./AvatarCameraIcon.jsx": 5265,
	"./AwningIcon.jsx": 3496,
	"./BallIcon.jsx": 6643,
	"./BarcodeIcon.jsx": 9177,
	"./BeveragesIcon.jsx": 9024,
	"./BoxIcon.jsx": 9103,
	"./CalendarIcon.jsx": 4419,
	"./CancelIcon.jsx": 7100,
	"./CanceledIcon.jsx": 5868,
	"./CarIcon.jsx": 1790,
	"./CarOrderIcon.jsx": 4949,
	"./CarPlusIcon.jsx": 3045,
	"./CarTransporterIcon.jsx": 3656,
	"./CardIcon.jsx": 8747,
	"./CheckCircleIcon.jsx": 9284,
	"./CheckIcon.jsx": 2623,
	"./CheckVerifiedIcon.jsx": 443,
	"./CheckmarkIcon.jsx": 5082,
	"./ChevronIcon.jsx": 7072,
	"./CisternIcon.jsx": 5452,
	"./ClipIcon.jsx": 4346,
	"./ClockIcon.jsx": 7709,
	"./ClockIcon2.jsx": 9488,
	"./ClockLightIcon.jsx": 111,
	"./CloseIcon.jsx": 8100,
	"./CloseIconNew.jsx": 2526,
	"./ClosedEye.jsx": 6393,
	"./CommentIcon.jsx": 3356,
	"./CompanyTickIcon.jsx": 789,
	"./ConfectioneryIcon.jsx": 9916,
	"./ConstructionMaterialsIcon.jsx": 9649,
	"./ContainerIcon.jsx": 3049,
	"./ContainerShipIcon.jsx": 2069,
	"./ContractIcon.jsx": 2536,
	"./CopyIcon.jsx": 3360,
	"./CopyIconNew.jsx": 344,
	"./CoveredIcon.jsx": 9292,
	"./DangerIcon.jsx": 3610,
	"./DeleteIcon.jsx": 3060,
	"./DeleteNewIcon.jsx": 984,
	"./DimWeightIcon.jsx": 3411,
	"./DirectionsIcon.jsx": 3576,
	"./DistanceIcon.jsx": 8963,
	"./DocumentIcon.jsx": 3797,
	"./DocumentIconNew.jsx": 570,
	"./DocumentNewIcon.jsx": 5342,
	"./DotsIcon.jsx": 5511,
	"./DownloadIcon.jsx": 68,
	"./DraftsIcon.jsx": 3685,
	"./DumpTruckIcon.jsx": 1934,
	"./EditIcon.jsx": 2692,
	"./EditIconNew.jsx": 1606,
	"./EllipseIcon.jsx": 4683,
	"./EmailIcon.jsx": 2528,
	"./EmptyIcon.jsx": 3938,
	"./EquipmentIcon.jsx": 3099,
	"./ErrorIcon.jsx": 8293,
	"./EtsngCodeIcon.jsx": 8799,
	"./ExitIcon.jsx": 2686,
	"./ExpeditorRejectedIcon.jsx": 254,
	"./ExportIcon.jsx": 2879,
	"./EyeIcon.jsx": 164,
	"./FertilizeIcon.jsx": 7066,
	"./FilterIcon.jsx": 3179,
	"./FoodIcon.jsx": 1451,
	"./FullScreenIcon.jsx": 8877,
	"./FurnitureIcon.jsx": 5963,
	"./GarageIcon.jsx": 7094,
	"./GlassProductsIcon.jsx": 1787,
	"./GngCodeIcon.jsx": 5710,
	"./HandshakeIcon.jsx": 3486,
	"./HintIcon.jsx": 1236,
	"./HomeIcon.jsx": 4027,
	"./HouseIcon.jsx": 2033,
	"./InactiveRadioButtonIcon.jsx": 8270,
	"./InfoIcon.jsx": 1788,
	"./InsurancePhoneCloseIcon.jsx": 3570,
	"./IsothermalIcon.jsx": 1622,
	"./LightningBoldIcon.jsx": 1501,
	"./LineFlexIcon.jsx": 6014,
	"./LineIcon.jsx": 7527,
	"./LocationIcon.jsx": 435,
	"./LocationIconNew.jsx": 8302,
	"./LogoIcon.jsx": 6036,
	"./Logotype.jsx": 340,
	"./LupeIcon.jsx": 3058,
	"./MailIcon.jsx": 5112,
	"./MenuIcon.jsx": 5064,
	"./MetalCansIcon.jsx": 619,
	"./MetalIcon.jsx": 7800,
	"./MoneyIcon.jsx": 2513,
	"./MoreIcon.jsx": 18,
	"./NotVerifiedIcon.jsx": 6998,
	"./NotificationIcon.jsx": 9366,
	"./NotificationIconNew.jsx": 8776,
	"./OnboardIcon.jsx": 2025,
	"./OrderCreationAuctionIcon.jsx": 8660,
	"./OrderCreationDirectIcon.jsx": 2354,
	"./OrderCreationGroupIcon.jsx": 3032,
	"./OrderCreationInfoIcon.jsx": 2777,
	"./OrderCreationTenderIcon.jsx": 215,
	"./OrderSearchIcon.jsx": 4548,
	"./OrdersIcon.jsx": 7827,
	"./OrgIcon.jsx": 3548,
	"./PalletIcon.jsx": 1301,
	"./PartnerIcon.jsx": 7242,
	"./PharmaceuticalsIcon.jsx": 9385,
	"./PhoneIcon.jsx": 827,
	"./PhotoHistoryIcon.jsx": 5857,
	"./PinIcon.jsx": 7924,
	"./PlaneIcon.jsx": 3499,
	"./PlatformIcon.jsx": 3571,
	"./PlusIcon.jsx": 1615,
	"./PolicyIcon.jsx": 244,
	"./RailwayIcon.jsx": 7185,
	"./ReassignUsersIcon.jsx": 2570,
	"./RefreshIcon.jsx": 7712,
	"./RefrigeratorIcon.jsx": 1547,
	"./ReloadIcon.jsx": 1129,
	"./RouteChevronIcon.jsx": 9823,
	"./RouteConnectorIcon.jsx": 8605,
	"./ScalesIcon.jsx": 5186,
	"./SealCheckIcon.jsx": 7180,
	"./SearchIcon.jsx": 728,
	"./SecurityIcon.jsx": 4194,
	"./SenderIcon.jsx": 1860,
	"./SettingsIcon.jsx": 9868,
	"./ShareSquareIcon.jsx": 1080,
	"./ShieldCheckIcon.jsx": 1033,
	"./StarIcon.jsx": 2908,
	"./SupportIcon.jsx": 6946,
	"./SupportIconMenu.jsx": 3330,
	"./TelegramIcon.jsx": 618,
	"./TemperatureIcon.jsx": 8874,
	"./TenderAssignmentMethodIcon.jsx": 865,
	"./TenderIcon.jsx": 6630,
	"./TickIcon.jsx": 3524,
	"./TobaccoIcon.jsx": 6358,
	"./ToggleSwitchIcon.jsx": 4704,
	"./ToggleSwitchNo.jsx": 7225,
	"./ToggleSwitchYes.jsx": 6526,
	"./ToolsIcon.jsx": 8166,
	"./TransportCompanyIcon.jsx": 2145,
	"./TransportCoveredIcon.jsx": 725,
	"./TransportCoveredIconNew.jsx": 612,
	"./TransportIsothermIcon.jsx": 2964,
	"./TransportIsothermIconNew.jsx": 5482,
	"./TransportRefrigeratorIcon.jsx": 7963,
	"./TransportRefrigeratorIconNew.jsx": 9889,
	"./TransportTentIcon.jsx": 6048,
	"./TransportTentIconNew.jsx": 1168,
	"./UncheckCircleIcon.jsx": 3721,
	"./UnloadIcon.jsx": 5790,
	"./UploadCloudIcon.jsx": 4182,
	"./UploadIcon.jsx": 5102,
	"./UserIcon.jsx": 7286,
	"./UserPlusIcon.jsx": 487,
	"./UserProfileIcon.jsx": 1692,
	"./UsersIcon.jsx": 928,
	"./VerificationIcon.jsx": 5767,
	"./ViberIcon.jsx": 6614,
	"./WagonTypeIcon.jsx": 5215,
	"./WagonsCountIcon.jsx": 3423,
	"./WalletIcon.jsx": 7532,
	"./WeightIcon.jsx": 3997,
	"./WhatsappIcon.jsx": 7454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6612;